module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "header__link",
    attrs: {
      "to": {
        name: 'profile-cabinet'
      }
    }
  }, [_vm._v("Назад в кабинет")]), _c('h2', {
    staticClass: "header__name"
  }, [_vm._v("Достижения: " + _vm._s(_vm.name))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323e8162","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/components/header/Header.vue
// module id = 7dc653a57ff42b756995
// module chunks = 11